import { common } from '../main/common-sidecar'
import { scene } from '../main/scene-sidecar'
import { IStevieText } from '../uiParts/stevieText'
import { stevieText } from '../uiParts/stevieText-sidecar'
import { IButton } from '../uiParts/buttons'
import { l } from '../lib/imports'
import { buttons } from '../uiParts/buttons-sidecar'
import { layers } from '../main/layers-sidecar'

interface IData {
  isOpen: boolean
  texts: IStevieText[]
  buttons: IButton[]
  lines: string[]
  stage: number
  substage: number
  delay: number
}
let _data: IData | null = null

export const getData = () => {
  if (!_data) {
    _data = {
      isOpen: false,
      texts: [],
      buttons: [],
      lines: [],
      stage: 0,
      substage: 0,
      delay: 0,
    }
    doClose()
  }

  let x = 100
  let y = 50 + 50
  let line = ''
  let ctx = scene.getContext()

  let st = stevieText.create(ctx.font24, x, y)
  stevieText.setText(st, '')
  _data.texts.push(st)
  line = 'they are coming for your treasure...'
  _data.lines.push(line)

  y += 50
  x += 50
  st = stevieText.create(ctx.font24, x, y)
  stevieText.setText(st, '')
  _data.texts.push(st)
  line = 'they are coming to smash your barrels...'
  _data.lines.push(line)

  y += 50
  x += 50
  st = stevieText.create(ctx.font24, x, y)
  stevieText.setText(st, '')
  _data.texts.push(st)
  line = 'you must...'
  _data.lines.push(line)

  y += 50 + 50
  x += 50
  st = stevieText.create(ctx.font32, x, y)
  stevieText.setText(st, '')
  _data.texts.push(st)
  line = '-DEFEND your DUNGEON!-'
  _data.lines.push(line)

  y += 30
  x += 130
  // st = stevieText.create(ctx.font32, x, y)
  // stevieText.setText(st, '')
  // _data.texts.push(st)
  // line = '-DEFENCE-'
  // _data.lines.push(line)

  y += 75 + 200
  x += 20
  let b = buttons.create(layers.getLayers().ui, x, y, 'Start Game', () => {
    doClose()
    scene.startGame()
  })
  _data.buttons.push(b)

  return _data
}

export const doClose = () => {
  let data = getData()
  data.isOpen = false
  l.forEach(data.texts, (c) => {
    stevieText.setVisible(c, false)
  })
  l.forEach(data.buttons, (c) => {
    buttons.setVisible(c, false)
  })
}

export const open = async () => {
  let data = getData()
  if (data.isOpen) {
    // close()
    return
  }

  data.isOpen = true
  l.forEach(data.texts, (c) => {
    stevieText.setVisible(c, true)
  })
  l.forEach(data.buttons, (c) => {
    buttons.setVisible(c, true)
  })
}

export const update = () => {
  // TODO: if active
  let s = common.getPhaserScene()
  let ctx = scene.getContext()

  if (_data && _data.isOpen) {
    _data.delay--
    if (_data.delay < 0) {
      _data.delay = 1
      _data.substage++

      // console.log('ss', _data.substage)
      if (_data.stage < _data.lines.length) {
        let idx = _data.stage
        let line = _data.lines[idx]
        let visibleLine = line.substring(0, _data.substage)
        stevieText.setText(_data.texts[idx], visibleLine)

        if (visibleLine === line) {
          _data.stage++
          _data.delay = 40
          _data.substage = 0
        }

        // console.log('ss', _data.substage)
      }
    }
  }
}
